module.exports = __webpack_public_path__ + "static/media/call-24px.f3b7d629.svg";